import { Model, modelRegistry } from './Model';
import { Product } from '.';
import HashGen from '../utilities/HashGen';
import Money from '../utilities/Money';
import { I18n } from '../wrappers/I18n';
export class WriteOffItem extends Model {
    static entity = 'write_off_items';
    id = null;
    write_off_id = null;
    date = null;
    product_id = null;
    unit_of_measure = null;
    tax_rate = '0.00';
    quantity = '1.000';
    selling_price = '0.0000';
    selling_price_after_tax = '0.0000';
    recorded_at = null;
    created_at = null;
    updated_at = null;
    hash = '';
    static fields() {
        return {
            id: this.attr(null),
            write_off_id: this.attr(null),
            date: this.attr(null),
            product_id: this.attr(null),
            unit_of_measure: this.attr(null),
            tax_rate: this.attr('0.00', value => this.round(value, 2).toFixed(2)),
            quantity: this.attr('1.000', value => this.round(value, 3).toFixed(3)),
            selling_price: this.attr('0.0000', value => this.round(value, 4).toFixed(4)),
            selling_price_after_tax: this.attr('0.0000', value => this.round(value, 4).toFixed(4)),
            recorded_at: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            hash: this.attr(HashGen.regular()),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    getTaxRate() {
        return parseFloat(this.tax_rate);
    }
    getQuantity() {
        return parseFloat(this.quantity);
    }
    getSellingPrice() {
        return Money.parse(this.selling_price);
    }
    getSellingPriceAfterTax() {
        return Money.parse(this.selling_price_after_tax);
    }
    getSellingValue() {
        const value = this.getSellingPrice()
            .multiply(this.getQuantity());
        return Money.parse(value.toFormat('0.0000'));
    }
    getTax() {
        const value = this.getSellingValue()
            .multiply(this.getTaxRate() / 100);
        return Money.parse(value.toFormat('0.0000'));
    }
    getSellingValueAfterTax() {
        const value = this.getSellingValue()
            .add(this.getTax());
        return Money.parse(value.toFormat('0.0000'));
    }
    getProduct() {
        return Product.find(this.product_id);
    }
    getUnitOfMeasure() {
        return I18n.t(`products.unit_of_measure.${this.unit_of_measure}`) !== `products.unit_of_measure.${this.unit_of_measure}`
            ? I18n.t(`products.unit_of_measure.${this.unit_of_measure}`)
            : this.unit_of_measure;
    }
}
export default WriteOffItem;
modelRegistry.register('WriteOffItem', WriteOffItem);
//# sourceMappingURL=WriteOffItem.js.map